import { render, staticRenderFns } from "./MessageRender.vue?vue&type=template&id=73aa7574"
import script from "./MessageRender.vue?vue&type=script&lang=js"
export * from "./MessageRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports